var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"fileUpload"}},[_c('el-upload',{attrs:{"action":_vm.action,"headers":{ ['Authorization']: 'Bearer ' + _vm.token },"show-file-list":false,"data":_vm.data,"before-upload":() => {
        _vm.loading = true;
      },"on-error":() => {
        _vm.loading = false;
      },"on-success":_vm.handleSuccess}},[_c('el-button',{attrs:{"size":"small","type":"primary","loading":_vm.loading}},[_vm._v(_vm._s(_vm.title))])],1),(_vm.previewUrl)?_c('el-link',{staticClass:"previewUrl",attrs:{"href":_vm.previewUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.previewUrl))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }